import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onChange", "onFocus", "onBlur"];
import React from 'react';
/**
 * Modifies on- change/focus/blur events to return value as first argument and keep event as second
 */
export function withEventValues(WrappedInput) {
  var CanonicalInput = function CanonicalInput(_ref) {
    var onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      props = _objectWithoutProperties(_ref, _excluded);
    /**
     * we have to override onChange, onFocus and onBlur,
     * normally they fire with event as first argument,
     * we put value as first argument, event as second
     */
    var handleChange = function handleChange(event) {
      if (onChange) onChange(event.target.value || '', event);
    };
    var handleFocus = function handleFocus(event) {
      if (onFocus) onFocus(props.value || '', event);
    };
    var handleBlur = function handleBlur(event) {
      if (onBlur) onBlur(props.value || '', event);
    };

    /**
     * Fields like status and size are passed straight into class, the validation is done in propTypes
     */
    return /*#__PURE__*/React.createElement(WrappedInput, _extends({}, props, {
      onBlur: handleBlur,
      onChange: handleChange,
      onFocus: handleFocus,
      "data-t-id": "src-utils"
    }));
  };

  /**
   * Override component name by prepending `Canonical~`
   * to make it look nice, for example: `CanonicalTextInput`
   */
  if (process.env.NODE_ENV !== 'production') {
    var WrappedComponentName = WrappedInput.displayName || WrappedInput.name || 'Input';
    CanonicalInput.displayName = "Canonical".concat(WrappedComponentName);
  }
  return CanonicalInput;
}